// extracted by mini-css-extract-plugin
module.exports = {"SidebarOpen":"dAnIY","SidebarClose":"_3aOyL"};